<template>
    

   
    <div class="title">
        资产列表
    </div>
    
    <XIASearchBar @search="search" :searchData="searchData" />
    <el-button type="primary" style="margin: 20px;" @click="dialogFormVisible2 = true">新增</el-button>
    <TableComponent :tableObjet="tableObjet" :headers="headers">

        <template #all_price="s">
            {{ s.row.number * s.row.price }}
        </template>

        <template #qrcode="scoped">

            <div @click="fangda(scoped.row)">
                <vue-qr :logoScale="0.2" logoSrc="favicon.ico" :margin="5"
                    :text="'https://erp.jimoveebikes.com/#/?id=' + scoped.row.id" :size="100"></vue-qr>
            </div>
        </template>
        <template #zj_price="s">
            {{ s.row.number * s.row.price - ((s.row.number * s.row.price) * s.row.zjl * s.row.ysy_nx * 0.01) }}
        </template>

        <template #caozuo="s">

            <div>
                <div>
                    <el-popconfirm title="确定删除该资产?" @confirm="removeAsset(s.row.id)">
                        <template #reference>
                            <el-button type="danger" plain round icon="Delete" small>删除</el-button>
                        </template>
                    </el-popconfirm>
                </div>
                <div style="margin-top: 10px;">
                    <el-button small round icon="Edit" @click="dialogFormVisible3 = true; item = s.row">编辑</el-button>
                </div>
            </div>

        </template>
    </TableComponent>
    <el-dialog v-model="dialogFormVisible2" title="新增资产">

        <div class="flex d">
            <div class="l">分类</div>
            <div class="r">
                <el-select v-model="a_type">
                    <el-option v-for="i in o" :value="i.value" :key="i.value" :label="i.label">{{ i.label }}</el-option>
                </el-select>
            </div>
        </div>
        <div class="flex d">
            <div class="l">名称</div>
            <div class="r">
                <el-input type="text" name="" id="" v-model="a_name" placeholder="请输入名称" style="width: 200px;" />
            </div>
        </div>
        <div class="flex d">
            <div class="l">价值</div>
            <div class="r">
                <el-input type="text" name="" id="" v-model="a_price" placeholder="请输入价值" style="width: 200px;" />
            </div>
        </div>
        <div class="flex d">
            <div class="l">数量</div>
            <div class="r">
                <el-input type="text" name="" id="" v-model="a_number" placeholder="请输入数量" style="width: 200px;" />
            </div>
        </div>
        <div class="flex d">
            <div class="l">使用年限(年)</div>
            <div class="r">
                <el-input type="text" name="" id="" v-model="a_nx" placeholder="请输入使用年限" style="width: 200px;" />
            </div>
        </div>
        <div class="flex d">
            <div class="l">已使用年限(年)</div>
            <div class="r">
                <el-input type="text" name="" id="" v-model="a_ysy_nx" placeholder="请输入已使用年限" style="width: 200px;" />
            </div>
        </div>
        <div class="flex d">
            <div class="l">折旧率%</div>
            <div class="r">
                <el-input type="text" name="" id="" v-model="a_zjl" placeholder="请输入折旧率" style="width: 200px;" />
            </div>
        </div>


        <template #footer>

            <span class="dialog-footer">
                <el-button @click="dialogFormVisible2 = false">取消</el-button>
                <el-button type="primary" @click="commit2()">
                    新增
                </el-button>
            </span>

        </template>
    </el-dialog>
    <el-dialog v-model="dialogFormVisible3" title="修改资产">

        <div class="flex d">
            <div class="l">分类</div>
            <div class="r">
                <el-select v-model="item.type">
                    <el-option v-for="i in o" :value="i.value">{{ i.label }}</el-option>
                </el-select>
            </div>
        </div>
        <div class="flex d">
            <div class="l">名称</div>
            <div class="r">
                <el-input type="text" name="" id="" v-model="item.name" placeholder="请输入名称" style="width: 200px;" />
            </div>
        </div>
        <div class="flex d">
            <div class="l">价值</div>
            <div class="r">
                <el-input type="text" name="" id="" v-model="item.price" placeholder="请输入价值" style="width: 200px;" />
            </div>
        </div>
        <div class="flex d">
            <div class="l">数量</div>
            <div class="r">
                <el-input type="text" name="" id="" v-model="item.number" placeholder="请输入数量" style="width: 200px;" />
            </div>
        </div>
        <div class="flex d">
            <div class="l">使用年限(年)</div>
            <div class="r">
                <el-input type="text" name="" id="" v-model="item.nx" placeholder="请输入使用年限" style="width: 200px;" />
            </div>
        </div>
        <div class="flex d">
            <div class="l">已使用年限(年)</div>
            <div class="r">
                <el-input type="text" name="" id="" v-model="item.ysy_nx" placeholder="请输入已使用年限"
                    style="width: 200px;" />
            </div>
        </div>
        <div class="flex d">
            <div class="l">折旧率%</div>
            <div class="r">
                <el-input type="text" name="" id="" v-model="item.zjl" placeholder="请输入折旧率" style="width: 200px;" />
            </div>
        </div>


        <template #footer>

            <span class="dialog-footer">
                <el-button @click="dialogFormVisible3 = false">取消</el-button>
                <el-button type="primary" @click="commit3()">
                    修改
                </el-button>
            </span>

        </template>
    </el-dialog>

    <el-dialog v-model="dialogFormVisible" title="查看二维码">
        <div id="qrcode">
            <div >
                <div style="margin-bottom: 5px;text-align: center;">
                    <span style="margin: auto;">资产名称：{{ leaseItem.name }}</span>
                </div>
                <div>
                    &nbsp;
                </div>
               


                <div  style="margin-top: 5px;text-align: center;">
                    <vue-qr :logoScale="0.2" logoSrc="favicon.ico" @click="fangda(item.row)" :margin="0"
                    :text="'https://erp.jimoveebikes.com/#/?aid=' + leaseItem.id" :size="180"></vue-qr>
                </div>
                <div>
                    &nbsp;
                </div>
                <div style="margin-top: 5px;text-align: center;">
                    所属分类： {{ leaseItem.t_name }}
                </div>
            </div>

        </div>
        <template #footer>
            <span class="dialog-footer">
                <el-button type="primary" @click="dayin()">
                    打印
                </el-button>

                <el-button type="primary" @click="dialogFormVisible = false">
                    ok
                </el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script setup>
import TableComponent from '@/components/TableComponent.vue';
import XIASearchBar from '@/components/XIA-SearchBar.vue';
import { useIndex } from "@/use/asset"
import { churuku, getProduct } from "@/api/product"
import { addAsset, removeAssetForId, xgAsset } from "@/api/asset"
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
import print from "print-js"
import { ref } from "vue"
import { ElMessage } from 'element-plus';

const { search, searchData, tableObjet, headers, o } = useIndex()
const dialogFormVisible2 = ref()
const dialogFormVisible3 = ref()
const a_name = ref("")
const a_price = ref()
const a_number = ref()
const a_nx = ref()
const a_ysy_nx = ref()
const a_zjl = ref()
const a_type = ref()
const item = ref({})
const commit2 = () => {
    if (!a_type.value) {
        ElMessage.error("请选择资产分类")
        return;
    }
    if (a_name.value == "") {
        ElMessage.error("请输入资产名称")
        return;
    }
    if (!a_price.value) {
        ElMessage.error("请输入资产价值")
        return;
    }
    if (!a_number.value) {
        ElMessage.error("请输入资产数量")
        return;
    }
    if (!a_nx.value) {
        ElMessage.error("请输入使用年限")
        return;
    }
    if (!a_ysy_nx.value) {
        ElMessage.error("请输入已使用年限")
        return;
    }
    if (!a_zjl.value) {
        ElMessage.error("请输入已使用年限")
        return;
    }
    addAsset({ type: a_type.value, name: a_name.value, price: a_price.value, number: a_number.value, nx: a_nx.value, ysy_nx: a_ysy_nx.value, zjl: a_zjl.value }).then(res => {
        if (res.code == 200) {
            dialogFormVisible2.value = false
            ElMessage.success(res.msg)
        } else {
            ElMessage.error(res.msg)
        }
    })
}

const commit3 = () => {
    xgAsset({ ...item.value }).then(res => {
        if (res.code == 200) {
            dialogFormVisible3.value = false
            ElMessage.success(res.msg)
            search()
        } else {
            ElMessage.error(res.msg)
        }
    })

}
const removeAsset = (id) => {
    removeAssetForId({ id }).then(res => {
        if (res.code == 200) {
            ElMessage.success(res.msg)
            search()
        } else {
            ElMessage.error(res.msg)
        }
    })
}


const fangda = (item) => {
    dialogFormVisible.value = true
    leaseItem.value = item
}
const dialogFormVisible = ref()
const currItem = ref()
const leaseItem = ref()

const dayin = () => {

// const LODOP = getLodop()

// LODOP.ADD_PRINT_HTM(0, 0, '100%', '100%', document.getElementById('qrcode').innerHTML)
// LODOP.ADD_PRINT_HTM(0,0,'100%','100%',document.getElementById('qrcode').innerHTML)
// LODOP.SET_PRINT_PAGESIZE(1, 650, 710, "qrcode");
//LODOP.PREVIEW();
// LODOP.PRINT();
// LODOP.PRINT();
// return
print({
    printable: 'qrcode',
    type: "html",
    style: "",

})
return
// print the html string

// 获取要打印的节点
const node = document.getElementById('qrcode');

// 创建一个新的 jsPDF 实例
const doc = new jsPDF();

// 将节点的 HTML 内容添加到 PDF 中
doc.html(node, {
    callback: function () {
        // 调用浏览器的打印对话框
        window.print();
    }
});
//window.print()
// print the dom element
//const  content= document.getElementById('qrcode')
//callPrinter(`<img src="https://api.qrserver.com/v1/create-qr-code/?size=150%C3%97150&data=https://jimove.jimoveebikes.com/080265295"/>22`)
}
</script>

<style lang="scss" scoped></style>